/// <amd-module name="Wit/HtmlEditor/Plugins/EditorProviderPlugin" />
import { Editor, EditorPlugin, PluginEvent } from "roosterjs-react";

export interface IEditorProvider {
    getEditor(): Editor;
}

/**
 * By default components that use a `LeanRooster` don't have access to its instance of the `Editor`
 * class - we only get that in event handlers and plugins. The purpose of this plugin is to provide
 * a handle to the Editor.
 */
export class EditorProviderPlugin implements EditorPlugin, IEditorProvider {
    private _editor: Editor;

    public getName(): string {
        return "EditorProviderPlugin";
    }

    public dispose(): void {    }

    public initialize(editor: Editor): void {
        this._editor = editor;
    }

    public onPluginEvent(_event: PluginEvent): void {
    }

    public getEditor() {
        return this._editor;
    }
}
